import * as Yup from 'yup';
import {  INDUSTRY_REQUIRED } from '../../../constant/message';

export const industrySchema = Yup.object().shape({
  name: Yup.string().required(INDUSTRY_REQUIRED)
});
